import { render } from "./UserBar.vue?vue&type=template&id=4c2346d0&ts=true&lang=pug"
import script from "./UserBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBar.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__